import React, { useState } from 'react';
import { Drawer, Button, Input, Form } from 'antd';
import { showToastSuccess } from 'src/utilities/toast';

const SendEmailDrawer = ({ isOpen, onClose }) => {
  const [emails, setEmails] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSend = () => {
    setLoading(true);
    setTimeout(() => {
      showToastSuccess('Email(s) sent successfully!');
      setLoading(false);
      setEmails('');
      onClose();
    }, 800);
  };

  return (
    <Drawer
      title="Send Document as Email"
      placement="right"
      width={400}
      onClose={onClose}
      open={isOpen}
      footer={
        <div className="flex justify-end items-center gap-2">
          <Button onClick={onClose}>Cancel</Button>
          <Button
            type="primary"
            onClick={handleSend}
            loading={loading}
            className="ih-button-primary"
            disabled={!emails.trim()}
          >
            Send Email
          </Button>
        </div>
      }
    >
      <Form layout="vertical">
        <Form.Item
          label="Email address(es)"
          extra="You can enter multiple email addresses separated by commas."
        >
          <Input.TextArea
            autoFocus
            autoComplete="off"
            rows={3}
            placeholder="Enter email addresses, separated by commas"
            value={emails}
            onChange={(e) => setEmails(e.target.value)}
            style={{ resize: 'none' }}
          />
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default SendEmailDrawer;
